import { parseCommand } from '../../utils/index.js';
import { FunctionButtonKind, FunctionName, ParserStatus } from '../../types/index.js';
import { ParserKeyError } from '../errors/index.js';
const rosterItemParserKey = 'j';
const functionButtonsParser = (param = null) => {
    if (param === null) {
        return {};
    }
    const buttons = param.split('/');
    return buttons.reduce((accum, button, index) => {
        const [display, isPress] = button.split(/(\*)/).reverse();
        const kind = (isPress == null && !isPress) ? FunctionButtonKind.TOGGLE : FunctionButtonKind.PRESS;
        accum[index] = {
            display,
            kind
        };
        return accum;
    }, {});
};
const parseFromCommand = ({ key, attributes }) => {
    const [cabId, display, rawFunctionButtons] = attributes;
    if (key !== rosterItemParserKey) {
        throw new ParserKeyError('rosterItemParser', key);
    }
    const functionButtons = functionButtonsParser(rawFunctionButtons);
    return {
        key: rosterItemParserKey,
        parser: FunctionName.ROSTER_ITEM,
        status: ParserStatus.SUCCESS,
        params: {
            cabId: parseInt(cabId),
            display,
            functionButtons
        }
    };
};
export const rosterItemParser = (command) => {
    const commandParams = parseCommand(command);
    return parseFromCommand(commandParams);
};
